import Vue from "vue";
import AnnouncementCard from "./AnnouncementCard.vue";

export function load() {
    const selector = "Announcement-card-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
          createElement(AnnouncementCard, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
